import { SkeletonBox, SkeletonText } from "@ui/components/Skeleton";
import { tv } from "@ui/lib/tv";

const cardSkeleton = tv({
  slots: {
    root: "flex w-full flex-col gap-3 md:gap-2.5",
    content: "flex flex-col gap-2",
    authorRow: "flex items-center gap-2",
  },
});

export interface CardSkeletonProps {
  className?: string;
  /** Description placeholder lines under the title (via `SkeletonText`, capped at 4). Default 0. */
  lines?: number;
  /** Render an author row (avatar + name) after the text lines. */
  withAuthor?: boolean;
  /** Render a short price line at the end. */
  withPrice?: boolean;
}

/** Loading placeholder matching the standard card shape: square image, title bar,
 *  then optional description lines / author row / price line. */
export function CardSkeleton({ className, lines = 0, withAuthor, withPrice }: CardSkeletonProps) {
  const styles = cardSkeleton();

  return (
    <div className={styles.root({ className })}>
      <SkeletonBox className="aspect-square" rounded="xl" />
      <div className={styles.content()}>
        <SkeletonBox className="h-6 w-3/4" />
        {lines > 0 ? <SkeletonText lines={lines} /> : null}
        {withAuthor ? (
          <div className={styles.authorRow()}>
            <SkeletonBox className="size-6 shrink-0" rounded="full" />
            <SkeletonBox className="h-5 w-1/2" />
          </div>
        ) : null}
        {withPrice ? <SkeletonBox className="h-5 w-1/3" /> : null}
      </div>
    </div>
  );
}
